import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import { IKeyhighlight } from './key-highlights.interface';

@Component({
  selector: 'app-key-highlights',
  templateUrl: './key-highlights.component.html',
  styleUrls: ['./key-highlights.component.scss'],
})
export class KeyHighlightsComponent implements OnInit {
  keyHighlights: IKeyhighlight[] = [];
  loading = false;
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loading = true;
    // const id = this.route.snapshot.paramMap.get('id');
    this.homeServiceRef.getEngagementId().subscribe(enagementId=>{
      const id = enagementId;
      this.loading = true;
      if (id) {
        this.homeServiceRef.getKeyHighlights(id).subscribe((res) => {
          this.keyHighlights = res;
          this.loading = false;
        });
      }
    });
  }
}
